import * as actionTypes from './action-types';

const STORAGE_KEY = 'metricsFilterSettings';

export const DEFAULT_METRICS_FILTERS = {
  location_id: null,
  turbine_data_id: null,
  forecast_config_ids: [],
  metric_id: null,
  horizon: null,
  aggregation: '',
  from: null,
  to: null
};

const loadStoredMetrics = () => {
  if (typeof window === 'undefined') {
    return { filters: { ...DEFAULT_METRICS_FILTERS }, hasApplied: false };
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { filters: { ...DEFAULT_METRICS_FILTERS }, hasApplied: false };
    }

    const parsed = JSON.parse(raw);

    return {
      filters: {
        ...DEFAULT_METRICS_FILTERS,
        location_id: parsed.location_id ?? null,
        turbine_data_id: parsed.turbine_data_id ?? null,
        forecast_config_ids: Array.isArray(parsed.forecast_config_ids)
          ? parsed.forecast_config_ids
          : [],
        metric_id: parsed.metric_id ?? null,
        horizon: parsed.horizon ?? null,
        aggregation: parsed.aggregation ?? '',
        from: parsed.from ?? null,
        to: parsed.to ?? null
      },
      hasApplied: Boolean(parsed.hasApplied)
    };
  } catch {
    return { filters: { ...DEFAULT_METRICS_FILTERS }, hasApplied: false };
  }
};

const persistMetrics = (filters, hasApplied) => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...filters,
        hasApplied
      })
    );
  } catch {
    // ignore quota / private mode errors
  }
};

const storedMetrics = loadStoredMetrics();

export const initialState = {
  filters: storedMetrics.filters,
  hasApplied: storedMetrics.hasApplied
};

const metricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_METRICS_FILTERS: {
      const next = {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };
      persistMetrics(next.filters, next.hasApplied);
      return next;
    }
    case actionTypes.SET_METRICS_HAS_APPLIED: {
      const next = {
        ...state,
        hasApplied: action.payload
      };
      persistMetrics(next.filters, next.hasApplied);
      return next;
    }
    default:
      return state;
  }
};

export default metricsReducer;
